<template>
  <div class="Footer">
   <div class="footer-container">
    <!-- <div class="footer-menu-section-desktop-view<template>
   <div class="Footer">
     <div class="footer-container"> -->
    <!-- <div class="footer-menu-section-desktop-view"> -->
    <div class="list">
     <div @click="goToLink('/')">
      <img src="../../assets/images/logo/logo1.png" class="cursor-pointer footer-logo" />
     </div>
     <div class="">
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideAboutUs' })">ABOUT US</div>
 
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideContactUs' })">CONTACT US</div>
 
      <div class="footer-menu" v-if="currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('nuvama.stockants.com')" @click="$router.push({ name: 'BrokerDisclaimerPreSignUp' })">BROKER DISCLAIMER</div>
      <div class="footer-menu" v-if="currentUrl.includes('hensex.stockants.com')">
       <a href="https://www.hensexsecurities.com/research-analyst-disclosures-disclaimers/" target="_blank" style="text-decoration: none; color: #606266">BROKER DISCLAIMER</a>
      </div>
      <div class="footer-menu" v-if="currentUrl.includes('gcl.stockants.com')">
       <a href="https://prod-api.stockants.com/Media/important_doc/Stockantscompliancenewgcl.pdf" download="GCL Disclaimer.pdf" style="text-decoration: none; color: #2d2e8d" target="_blank">BROKER DISCLAIMER</a>
      </div>
 
      <div class="footer-menu" @click="$router.push({ name: 'StockAntsCompliance' })">STOCKANTS COMPLIANCE</div>
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideFAQ' })">FAQs</div>
      <div class="footer-menu" @click="$router.push({ name: 'BecomeBusinessPartners' })">Become Business Partners</div>
     </div>
 
     <div class="" v-if="websiteUserType.userType != 'broker'">
      <div class="footer-menu" @click="$router.push({ name: 'RetailSidePrivacyPolicy' })">privacy policy</div>
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideTermsAndCondition' })">Terms & condition</div>
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideDisclaimer' })">DISCLAIMER</div>
      <div class="footer-menu" @click="$router.push({ name: 'RetailSideRefundAndCancelation' })">Refund and Cancellation Policy</div>
     </div>
 
     <div class="social-icon-container">
      <a :href="twitter_link" target="_blank">
       <img class="social-icon" src="../../assets/images/RetailSideLandingPurple/twitter 1.png" alt />
      </a>
      <a :href="fb_link" target="_blank">
       <img class="social-icon" src="../../assets/images/facebook.png" alt />
      </a>
      <a :href="linkedIn_link" target="_blank">
       <img class="social-icon" src="../../assets/images/linkedin.png" alt />
      </a>
      <a :href="whatsApp_link" target="_blank">
       <img class="social-icon" src="../../assets/images/whatsapp.png" alt />
      </a>
      <a :href="telegram_link" target="_blank">
       <img class="social-icon" src="../../assets/images/telegram.svg" alt />
      </a>
     </div>
    </div>
   </div>
   <div class="text-center bottom-disclaimer">
    <p>StockAnts is a service provider for price estimate tracking and aggregation, enabling retail users to make investment decisions.</p>
    <p>StockAnts neither offers algorithmic trading services/strategies to investors for automated execution of trades nor promotes any services of any broker for execution of trades.</p>
   </div>
  </div>
 </template>
 
 <script>
 import moment from 'moment';
 import { HelperNetworkCallBack } from '../../mixins/Helper';
 
 export default {
  mixins: [HelperNetworkCallBack],
  name: 'RetailFooter',
  data() {
   return {
    // gclPdf:
    //   serverHostName + "/Media/important_doc/Stockantscompliancenewgcl.pdf",
    twitter_link: 'https://twitter.com/StockAnts',
    fb_link: 'https://www.facebook.com/StockAnts/?view_public_for=186471548792050',
    linkedIn_link: 'https://www.linkedin.com/company/stockants/about/?viewAsMember=true',
    whatsApp_link: 'https://www.whatsapp.com/channel/0029Vas4r0FGehEP7GOA6W0R',
    telegram_link: 'https://t.me/stockants',
    moment: moment,
    routeName: '',
    userProfile: null,
    websiteUserType: {},
    currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
    userType: '',
   };
  },
 
  created() {},
 
  mounted() {
   // after logout save currentUrl
   if (!localStorage.getItem('currentUrl')) {
    this.selectUserType();
   }
 
   // select user type for navigation access
   if (localStorage.getItem('websiteUserType')) {
    this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
   }
 
   this.routeName = this.$route.name;
 
   if (localStorage.getItem('profile')) {
    this.userProfile = JSON.parse(localStorage.getItem('profile'));
   }
 
   if (localStorage.getItem('roles')) {
    var role = JSON.parse(localStorage.getItem('roles'));
    this.userType = role[0];
   } else if (localStorage.getItem('UserType')) {
    this.userType = localStorage.getItem('UserType');
   }
  },
 
  methods: {
   goToLink(link) {
    if (link) {
     window.open(link, '_blank');
     // this.$router.push(link);
    }
   },
  },
 };
 </script>
 
 <style scoped lang="scss">
 @import '../../css/variable.scss';
 @import '../../css/common.scss';
 
 .footer-container {
  background-color: #ffff;
  height: 140px;
  padding: 50px 0px 30px;
  margin-top: 40px;
 
  .list {
   display: flex;
   justify-content: space-around;
  }
 }
 
 .bottom-disclaimer {
  font-size: 12px;
  padding: 20px 20px 80px;
  margin: 0;
  color: #555555;
  background: #ffff;
 
  p {
   margin: 0;
  }
 }
 
 .footer-menu-section-desktop-view {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
 }
 
 .footer-menu-section-mobile-view {
  text-align: center;
 }
 
 .footer-menu {
  font-weight: 600;
  font-size: 12px;
  margin: 15px;
  white-space: nowrap;
  cursor: pointer;
  text-transform: uppercase;
  color: #2d2e8d;
 }
 
 .social-icon-container {
  display: flex;
 }
 
 .social-icon-container .social-icon {
  height: 35px;
  margin: 0 8px;
  cursor: pointer;
  transition: transform 0.2s;
  /* Animation */
 }
 
 .social-icon-container .social-icon:hover {
  transform: scale(1.1);
 }
 
 .footer-logo {
  width: 220px;
 }
 
 @media screen and (max-width: 700px) {
  .footer-container {
   margin-bottom: 100px;
  }
 
  .bottom-disclaimer {
   position: relative;
   bottom: 70px;
   // z-index: -1;
  }
 }
 
 @media screen and (max-width: 768px) {
  .footer-container {
   margin-top: 0;
   height: auto;
   text-align: left;
 
   .social-icon-container {
    margin-top: 40px;
    padding-left: 15px;
   }
 
   .list {
    display: unset;
   }
  }
 
  .footer-logo {
   margin: auto;
  }
 }
 </style>
 <style scoped lang="scss">
 @import '../../css/variable.scss';
 @import '../../css/common.scss';
 
 .footer-container {
  background-color: #ffff;
  height: 140px;
  padding: 50px 0px 30px;
  margin-top: 40px;
 
  .list {
   display: flex;
   justify-content: space-around;
  }
 }
 
 .bottom-disclaimer {
  font-size: 12px;
  // margin: 20px 20px 80px;
  color: #555555;
 
  p {
   margin: 0;
  }
 }
 
 .footer-menu-section-desktop-view {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
 }
 
 .footer-menu-section-mobile-view {
  text-align: center;
 }
 
 .footer-menu {
  font-weight: 600;
  font-size: 12px;
  margin: 15px;
  white-space: nowrap;
  cursor: pointer;
  text-transform: uppercase;
 }
 
 .social-icon-container {
  display: flex;
 }
 
 .social-icon-container .social-icon {
  height: 35px;
  margin: 0 5px;
  cursor: pointer;
  transition: transform 0.2s;
  /* Animation */
 }
 
 .social-icon-container .social-icon:hover {
  transform: scale(1.1);
 }
 
 .footer-logo {
  width: 185px;
 }
 
 @media screen and (max-width: 870px) {
  .social-icon-container .social-icon {
   height: 18px;
   margin: 0 4px;
  }
 }
 
 @media screen and (max-width: 700px) {
  .footer-container {
   margin-bottom: 100px;
  }
 
  .bottom-disclaimer {
   position: relative;
   bottom: 70px;
   // z-index: -1;
  }
 }
 
 @media screen and (max-width: 768px) {
  .footer-container {
   margin-top: 0;
   height: auto;
   text-align: left;
 
   .social-icon-container {
    margin-top: 40px;
   }
 
   .list {
    display: unset;
   }
  }
 
  .footer-logo {
   margin: auto;
  }
 }
 </style>